"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { Error as ErrorBase } from "@/app/_components/error";

import { handleError, type HandleErrorOptions } from "@/helper/error";
import { getAppUrl } from "@/helper/url";
interface ErrorProps extends Pick<HandleErrorOptions, "error"> {
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  const pathname = usePathname();

  useEffect(() => {
    handleError({
      error,
      pathname: `${getAppUrl()}${pathname}`,
      errorType: "ClientError",
    }).catch(console.error);
  }, [error, pathname]);

  return <ErrorBase reset={reset} />;
}
